import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

type ChangeOrganizationOwnerParams = {
    ownerId?: string;
};

export default async ({ ownerId }: ChangeOrganizationOwnerParams = {}) => {
    const tempHeaders = {
        auth: true,
        "x-owner-id": ownerId,
    };

    const httpResponse = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/organization/owner`,
        method: "put",
        headers: tempHeaders,
    });
    const { body, statusCode } = httpResponse;

    const errorFeedBacks = {};

    return handleStatusCases({
        body,
        statusCode,
        errorFeedBacks,
    });
};
